import client from "../../lib/api/client";

export const writeConveyor = ({ title, lineQty, conveyorType, applyCode, body, tags, project }) => {
    return client.post('/api/conveyors', {
        title,
        lineQty,
        conveyorType,
        applyCode,
        body,
        tags,
        project,
    });
};

export const readConveyor = (id) => {
    return client.get(`/api/conveyors/${id}`);
};

export const listConveyor = ({ projectId, page, username, tag }) => {
    return client.get('/api/conveyors', {
        params: { projectId, page, username, tag },
    });
    // GET /api/Conveyors?username=tester&page=2&tag=..와 같이 주소를 만들어 호출한다.
};

export const updateConveyor = ({ id, title, lineQty, conveyorType, applyCode, body, tags }) => {
    return client.patch(`/api/conveyors/${id}`, {
        title,
        lineQty,
        conveyorType,
        applyCode,
        body,
        tags,
    });
};

export const removeConveyor = (id) => {
    return client.delete(`/api/conveyors/${id}`);
};